import { EyeOutlined, SettingOutlined } from "@ant-design/icons";
import { Button, Skeleton, Space, Tooltip } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";

interface LocationActionsProps {
	record: any;
}

const LocationActions: React.FC<LocationActionsProps> = ({ record }) => {
	const navigate = useNavigate();

	if (record.isLoading) {
		return <Skeleton.Input style={{ width: 80 }} active size="small" />;
	}

	return (
		<Space size="small">
			<Tooltip title="View Location">
				<Button
					type="text"
					icon={<EyeOutlined />}
					size="small"
					onClick={(e) => {
						e.stopPropagation();
						navigate(`/locations/${record.id}`);
					}}
				/>
			</Tooltip>
			<Tooltip title="Location Settings">
				<Button
					type="text"
					icon={<SettingOutlined />}
					size="small"
					onClick={(e) => {
						e.stopPropagation();
						navigate(`/locations/${record.id}/settings`);
					}}
				/>
			</Tooltip>
		</Space>
	);
};

export { LocationActions };
